<template>
  <div class="ele-situation d-flex flex-column">
    <div
      class="selector-container section-container d-flex"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="用电概况"></SectionTitle>
      <project-level-selector
        @selectItem="selectItemListener"
        levelType="xm"
        style="margin-right: 1rem"
      ></project-level-selector>
    </div>
    <div class="none-height flex-grow-1 d-flex flex-column">
      <div
        class="ele-container brief-info section-container d-flex"
      >
        <elearea1 class="none-width flex-grow-1" :proId="proId"></elearea1>
        <elearea2 class="none-width flex-grow-1" :proId="proId"></elearea2>
      </div>
      <div
        class="ele-container none-height flex-grow-1 "
        :class="{ dark: skinType }"
      >
        <elearea3 :proId="proId"></elearea3>
      </div>
      <div
        class="ele-container none-height flex-grow-1 section-container"
        :class="{ dark: skinType }"
      >
        <elearea4 :proId="proId"></elearea4>
      </div>
    </div>
  </div>
</template>

<script>
import elearea1 from '@/components/realtime-monitoring/ele-situation/utils/elearea1.vue';
import elearea2 from '@/components/realtime-monitoring/ele-situation/utils/elearea2.vue';
import elearea3 from '@/components/realtime-monitoring/ele-situation/utils/elearea3.vue';
import elearea4 from '@/components/realtime-monitoring/ele-situation/utils/elearea4.vue';
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  name: 'ele-situation',
  data() {
    return {
      proId: '',
    };
  },
  components: {
    elearea1,
    elearea2,
    elearea3,
    elearea4,
    ProjectLevelSelector,
    SectionTitle,
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    selectItemListener(selectItem) {
      if (selectItem.oType === 'xm') {
        this.proId = selectItem.IdStr;
      }
    },
  },
};
</script>
<style scoped>
.section-header {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 1rem 0 0.5rem;
}
.ele-container + .ele-container {
  margin-top: 1rem;
}
.brief-info{
  height: 10rem;
}
</style>
